<template>
  <div>
    <div class="mb-2 p-4">
      <icon-view
        icon="fas fa-user-minus text-danger"
        title="Desasignar"
        variant="custom-icon-view"
        icon-background="white"
      />
      <validation-observer ref="unassignform" novalidate tag="form">
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <validation-provider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <custom-drop-down
                :options="reasons"
                label="Razón:"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                class="w-100 mb-4 bold-label"
                custom-error-msg="Favor seleccione una razón"
                :error="errors[0]"
                v-model="model.reason"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
      <custom-text-area
        show-char-count
        v-model="model.comment"
        placeholder="Escribe un comentario"
        label="Comentario:"
        custom-error-msg="Este campo es requerido"
        :count-classes="['d-block text-right']"
        :maxlength="3000"
      />
      <div class="d-flex justify-content-end align-items-center mt-4">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 px-3"
          @click="cancel"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success px-3"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomInput from "CustomInput";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import CustomDropDown from "custom-drop-down";

import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import StudentBookUnassignReasonTypes from "@/utils/constants/inventory/studentBookUnassignReasonTypes";


export default {
  name: "UnassignStudentBook",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomInput,
    CustomDropDown
  },
  mixins: [alertMixin],
  data() {
    return {
      reasons: [],
      model: {
        comment: null,
        reason: null
      }
    };
  },
  async mounted() {
    await this.getReasons();
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    async save() {
      const valid = await this.$refs.unassignform.validate();
      if (!valid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      const payload = {
        reasonId: this.model.reason.id,
        comment: this.model.comment
      };

      this.$emit("save", payload);
    },
    async getReasons() {
      const { data } = await inventoryCatalogService.getBookStudentUnassignReasons(
        StudentBookUnassignReasonTypes.Book
      );
      this.reasons = data;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-icon-view > .dot,
::v-deep .custom-icon-view-2 > .dot {
  padding: 15px;
  margin: 0px 5px 0px 0px;
}
::v-deep .custom-icon-view-2 > .dot {
  background: #ff7058 !important;
}
.border-left-4 {
  border-left: 4px solid #b5c3bc !important;
}
</style>
